import Link from 'next/link';
import styled from 'styled-components';

export const Item = styled(Link)`
  display: inline-flex;
  align-items: center;
  margin: 0 10px;
  color: white;
  transition: opacity 0.3s ease;
  font-size: 12px;
  font-weight: 600;
  &:hover {
    opacity: 0.75;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    > svg {
      font-size: large;
    }
  }
`;

export const Divider = styled.span`
  width: 1px;
  height: 14px;
  background-color: ${({ theme }) => theme.palette.primaryBrand};
`;

export const FlexDirectionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;
